import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

import { useDisableScroll } from 'hooks'

import Avatar from 'components/Avatar'

import { ReactComponent as SearchIcon } from 'icons/icon-search.svg'
import { ReactComponent as AllIcon } from 'icons/icon-mentionable-all.svg'

import { useMention } from '../useMention'

import { MentionableSearch } from './MentionableSearch/MentionableSearch'

import './style.scss'

const MentionablePopper = ({
  mention,
  openModal,
  enableMentionAll = false,
}: {
  mention: ReturnType<typeof useMention>
  openModal: () => void
  enableMentionAll: boolean
}) => {
  const { t } = useTranslation()

  useDisableScroll(!!mention.styles)

  if (!mention.styles) return null

  return (
    <div className="MentionableList">
      <div
        className="MentionableList__overlay"
        onClick={() => {
          mention?.reset()
        }}
      />

      <div className="MentionableList__box" style={mention?.styles}>
        {enableMentionAll && (
          <a
            className="MentionableList__box__a"
            onClick={() => {
              mention.select({ type: 'all' })
            }}
          >
            <div className="MentionableList__box__a__all">
              <AllIcon className="MentionableList__box__a__all__icon" />

              <div className="MentionableList__box__a__all__right">
                <p className="MentionableList__box__a__all__right__p">all</p>

                <small className="MentionableList__box__a__all__right__small">
                  {t('mentionable_list.all.small')}
                </small>
              </div>
            </div>
          </a>
        )}

        {mention.list?.map((user) => (
          <a
            className="MentionableList__box__a"
            key={user.id}
            onClick={() => {
              mention.select({
                user,
              })
            }}
            onMouseDown={(e) => {
              e.preventDefault()
            }}
          >
            <Avatar user={user} />
            <p>{user.nickname}</p>
          </a>
        ))}

        {!mention.isLoading && (
          <a
            className="MentionableList__box__a"
            onClick={() => {
              openModal()
              mention?.reset()
            }}
          >
            <SearchIcon className="MentionableList__box__a__search" />
            <p>{t('mentionable_list.search')}</p>
          </a>
        )}
      </div>
    </div>
  )
}

export const MentionableList = ({
  mention,
  enableMentionAll,
}: {
  mention: ReturnType<typeof useMention>
  enableMentionAll: boolean
}) => {
  const [isActive, setIsActive] = useState(false)

  const onClose = () => {
    setIsActive(false)
  }

  return (
    <>
      <MentionableSearch
        isActive={isActive}
        onClose={onClose}
        onSelect={mention.select}
      />

      {!isActive &&
        ReactDOM.createPortal(
          <MentionablePopper
            mention={mention}
            openModal={() => setIsActive(true)}
            enableMentionAll={enableMentionAll}
          />,
          document.querySelector('#mention')
        )}
    </>
  )
}
